export interface PreloaderProps {
  /**
   * A verse on the loading overlay. Optional, and three of the four apps pass nothing —
   * the overlay renders exactly as it always has without it.
   *
   * **It will usually not be read, and that is accepted.** `usePreloader` hides the overlay
   * as soon as the page is ready, which on a fast connection is a couple of hundred
   * milliseconds. The alternative is a minimum display time, which means deliberately
   * delaying every page load in order to show a verse — that makes the site worse, so the
   * verse is there for the slow connection and the cold cache, and nowhere else.
   */
  verse?: { text: string; reference: string }
}

/**
 * The full-screen loading overlay.
 *
 * Markup matches the source's `<div class="preloader" id="preloader"><div class="loader">`,
 * with the verse block added after the spinner so a screen reader meets the loading state
 * before the quotation.
 */
export function Preloader({ verse }: PreloaderProps) {
  return (
    <div className="preloader" id="preloader">
      <div className="loader" />
      {verse && (
        <figure className="preloader-verse">
          <blockquote>{verse.text}</blockquote>
          <figcaption>{verse.reference}</figcaption>
        </figure>
      )}
    </div>
  )
}
